/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IHeiProductDownloadsViewProps } from './hei-product-downloads';
import InnerHTML from 'dangerously-set-html-content';

export default (props: IHeiProductDownloadsViewProps) => {
    const {
        data: { productInfo },
        config: { heading }
    } = props;

    const html = productInfo.result?.DownloadInfoHtml;

    if (!html) {
        return null;
    }

    return (
        <div className='hei-product-downloads section-container'>
            {heading?.text && <Msdyn365.Text className='section-container-heading' tag={heading.tag ?? 'h2'} text={heading.text} />}
            <InnerHTML html={html} />
        </div>
    );
};
